// extracted by mini-css-extract-plugin
export default {"sider":"sider_R6RGv","header":"header_PPX84","content":"content_vpame"};